import React from 'react';
import { Redirect } from 'expo-router';
export default function BusinessWorkRedirect() { return <Redirect href="/work" />; }
